import { render, staticRenderFns } from "./morePolicySystem.vue?vue&type=template&id=b4708e10&"
import script from "@viewJs/home/morePolicySystem.js?vue&type=script&lang=js&"
export * from "@viewJs/home/morePolicySystem.js?vue&type=script&lang=js&"
import style0 from "./morePolicySystem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports